module.exports = __webpack_public_path__ + "static/media/20240530074723_IMG_7350-min.e186fb86.JPG";